"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SnackbarProvider = void 0;
exports.useSnackbar = useSnackbar;
var _jsxRuntime = require("@emotion/react/jsx-runtime");
var React = _interopRequireWildcard(require("react"));
var _assert = require("wnd-util/lib/assert");
var _infoBanner = require("../banners/infoBanner");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const snackbarContext = /*#__PURE__*/React.createContext({
  isSnackbarVisible: false,
  setSnackbarVisible: () => {
    console.warn('setSnackbarVisible was called but component is lacking a snackbar context. Ensure component is wrapped within a SnackbarProvider to use it correctly.');
  },
  showSuccessAlert: () => {
    console.warn('showSuccessAlert was called but component is lacking a snackbar context. Ensure component is wrapped within a SnackbarProvider to use it correctly.');
  },
  showErrorAlert: () => {
    console.warn('showErrorAlert was called but component is lacking a snackbar context. Ensure component is wrapped within a SnackbarProvider to use it correctly.');
  },
  showInfoAlert: () => {
    console.warn('showInfoAlert was called but component is lacking a snackbar context. Ensure component is wrapped within a SnackbarProvider to use it correctly.');
  },
  showWarningAlert: () => {
    console.warn('showWarningAlert was called but component is lacking a snackbar context. Ensure component is wrapped within a SnackbarProvider to use it correctly.');
  },
  snackbarMessage: '',
  snackbarType: _infoBanner.BannerType.Info
});
function useSnackbar() {
  const context = React.useContext(snackbarContext);
  (0, _assert.assertExists)(snackbarContext, 'This component must exist within a snackbarContext provider');
  return context;
}
const SnackbarProvider = ({
  children
}) => {
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [snackbarType, setSnackbarType] = React.useState(_infoBanner.BannerType.Info);
  const [isSnackbarVisible, setSnackbarVisible] = React.useState(false);
  function showSuccessAlert(message) {
    setSnackbarMessage(message);
    setSnackbarType(_infoBanner.BannerType.Success);
    setSnackbarVisible(true);
  }
  function showErrorAlert(message) {
    setSnackbarMessage(message);
    setSnackbarType(_infoBanner.BannerType.Error);
    setSnackbarVisible(true);
  }
  function showWarningAlert(message) {
    setSnackbarMessage(message);
    setSnackbarType(_infoBanner.BannerType.Warning);
    setSnackbarVisible(true);
  }
  function showInfoAlert(message) {
    setSnackbarMessage(message);
    setSnackbarType(_infoBanner.BannerType.Info);
    setSnackbarVisible(true);
  }
  return (0, _jsxRuntime.jsx)(snackbarContext.Provider, {
    value: {
      isSnackbarVisible,
      setSnackbarVisible,
      showErrorAlert,
      showInfoAlert,
      showSuccessAlert,
      showWarningAlert,
      snackbarMessage,
      snackbarType
    },
    children: children
  });
};
exports.SnackbarProvider = SnackbarProvider;